import React from "react"
import { UGC_PLATFORMS } from "../constants"

/**
 * Platform switcher. Only entries with `enabled: true` in `constants.js` are
 * clickable today (YouTube) - anything else renders as a disabled "Coming
 * soon" pill, so lighting up a new platform later is a one-line constants
 * change rather than a UI change.
 */
const PlatformTabs = ({ active, onChange }) => (
  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
    {UGC_PLATFORMS.map((platform) => {
      const isActive = platform.id === active
      return (
        <button
          key={platform.id}
          type="button"
          disabled={!platform.enabled}
          onClick={() => platform.enabled && onChange(platform.id)}
          title={platform.enabled ? undefined : "Coming soon"}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "7px",
            padding: "8px 14px",
            borderRadius: "10px",
            fontSize: "13px",
            fontWeight: 600,
            fontFamily: "Rubik",
            border: isActive ? `1px solid ${platform.color}` : "1px solid rgba(255,255,255,0.08)",
            background: isActive ? `${platform.color}18` : "rgba(255,255,255,0.02)",
            color: platform.enabled ? (isActive ? "#fff" : "#9ca3af") : "#565866",
            cursor: platform.enabled ? "pointer" : "not-allowed",
            opacity: platform.enabled ? 1 : 0.6,
          }}
        >
          <i className={platform.icon} style={{ color: platform.enabled ? platform.color : "#565866", fontSize: "13px" }} />
          {platform.label}
          {!platform.enabled && (
            <span style={{ fontSize: "10px", fontWeight: 700, background: "rgba(255,255,255,0.06)", padding: "1px 6px", borderRadius: "5px" }}>
              SOON
            </span>
          )}
        </button>
      )
    })}
  </div>
)

export default PlatformTabs
